import type { Nil, PartialWithNil } from "@mcwd/typescript-type-guards";
import { deleteEmptyProperties } from "@mcwd/util-parse-and-convert";
import { ValueGetters } from "../../../tracking/data/ValueGetters.js";
import type { SiteCountryCodeUppercase } from "../../../types-and-definitions/locale-defs/Locales.js";
import type { FormWidgetData } from "../../../widgetDataTs.js";
import type { SimpleForm_HiddenMarketoInputType } from "../../types/definitions/inputs/marketo-input-names-and-values.js";
import { getSourceWebsite } from "./getSourceWebsite.js";

export function getHiddenFieldValuesForSimpleForm (opts: {
  formTrackingName: string;
  leadSource: string | Nil;
  siteCountryCode: SiteCountryCodeUppercase;
  widgetData: FormWidgetData | Nil;
})
{
  const {
    formTrackingName, leadSource, widgetData, siteCountryCode,
  } = opts;
  const offerId = widgetData?.setup?.tracking?.offerId ?? null;
  const val: PartialWithNil<SimpleForm_HiddenMarketoInputType> = {
    FormName: formTrackingName,
    SiteLanguageCode: siteCountryCode,
    Website_Language_Code__c: siteCountryCode,
    Last_Offer_Campaign__c: offerId,
    source: leadSource,
    Campaign__c: ValueGetters.TacticId.value,
    Medium__c: ValueGetters.UtmMedium.value,
    Source__c: ValueGetters.UtmSource.value,
    Mobile__c: ValueGetters.IsMobileDevice.value,
    Source_Website: getSourceWebsite(siteCountryCode),
    Source_String__c: ValueGetters.PageName.value,
    GCLID__c: ValueGetters.Gclid.value,
  };
  return deleteEmptyProperties(val);
}
